import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export default function Mascot({ side = "right", flip = false, phrases, bubble, className = "", greet = false, fixed = false, img = "/mascot.png" }) {
  const userLines = phrases?.length ? phrases : bubble ? [bubble] : [];
  const lines = userLines.length ? ["Hey, I'm Rudi. Ready to Ride?", ...userLines] : [];
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(false);
  const [met, setMet] = useState(greet); // greet mascots introduce themselves on mount
  const hideTimer = useRef(null);

  // optional welcome: the bubble shows once on mount and auto-hides after 6 s
  useEffect(() => {
    if (!greet || !lines.length) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 6000);
    return () => clearTimeout(t);
  }, [greet]);

  useEffect(() => () => clearTimeout(hideTimer.current), []);

  const talk = () => {
    if (!lines.length) return;
    setVisible(true);
    if (met) {
      setIdx((i) => (i + 1) % lines.length);
    } else {
      setMet(true); // first-ever tap: Rudi introduces himself (intro is lines[0])
    }
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setVisible(false), 6000);
  };

  const current = lines.length ? lines[idx % lines.length] : null;
  const interactive = lines.length > 0;

  return (
    <button
      type="button"
      onClick={interactive ? talk : undefined}
      aria-label={interactive ? "Rudi says something" : undefined}
      className={`${fixed ? "fixed" : "absolute"} z-10 hidden lg:block ${interactive ? "cursor-pointer pointer-events-auto" : "pointer-events-none"} ${fixed ? "" : side === "right" ? "-right-12" : "-left-12"} ${className}`}
      data-testid={interactive ? "rudi-mascot-btn" : undefined}
    >
      <div className="relative">
        <motion.img
          src={img}
          alt=""
          className={`${fixed ? "w-24 xl:w-28" : "w-44 xl:w-56"} drop-shadow-[0_20px_32px_rgba(0,0,0,0.45)] ${flip ? "-scale-x-100" : ""}`}
          animate={{ y: [8, -4, 8], rotate: [0, flip ? -3 : 3, 0] }}
          transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
          whileTap={{ scale: 0.92 }}
        />
        {visible && current && (
          <motion.span
            key={`bubble-${idx}`}
            initial={{ opacity: 0, scale: 0.5, y: 8 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: -6 }}
            transition={{ type: "spring", stiffness: 260, damping: 16 }}
            className={`absolute top-1 w-56 rounded-2xl border-2 border-[#0a0a0b]/20 bg-[#fff7e8] px-4 py-2.5 text-base font-extrabold leading-snug text-[#0a0a0b] shadow-[0_10px_30px_rgba(0,0,0,0.4)] ${side === "right" ? "right-full mr-3" : "left-full ml-3"}`}
            data-testid="rudi-bubble"
          >
            {current}
          </motion.span>
        )}
      </div>
    </button>
  );
}
